import { Navigate, Outlet } from "react-router";
import { useSession } from "@/lib/auth-client";

export function PublicRoute() {
	const { data: session, isPending } = useSession();

	if (isPending) {
		return (
			<div className="min-h-screen flex items-center justify-center text-[12px] text-[var(--color-text-dim)]">
				loading…
			</div>
		);
	}

	// Send signed-in users to Index, which resolves the first project and
	// jumps to its graph view. Direct redirect to "/" would loop through
	// this guard if "/" lived underneath it.
	if (session?.user) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}
